import http from 'axios'

export default {
  getAllTemoignages: (onlyActif) => {
    return http.get(`/web/v1/abonnement/temoignage?onlyActif=${onlyActif}`)
  },
  createTemoignageAbonnement: (temoignageAbonnement) => {
    return http.post(`/web/v1/abonnement/temoignage`, temoignageAbonnement)
  },
  updateTemoignageAbonnement: (temoignageAbonnement) => {
    return http.put(`/web/v1/abonnement/temoignage`, temoignageAbonnement)
  },
  deleteTemoignageAbonnement: (temoignageID) => {
    return http.delete(`/web/v1/abonnement/temoignage/${temoignageID}`)
  },
}
